import { Stack } from '@mui/material';
import { useCallback, useState } from 'react';

import {
  CardDescription,
  CardTitle,
  IconBox,
  ServiceItemCard,
  TextBox,
} from './styles';
import { ServiceModal } from '../ServiceModal';
import { type MovementMenuService } from '../../hooks/useMovementMenuOptions/types';
import { useRedirectModalState } from '../../hooks';

export function ServiceItem({
  title,
  description,
  icon,
  primary,
  redirects,
}: Readonly<MovementMenuService>) {
  const [openServicesModal, setOpenServicesModal] = useState(false);
  const { changeRedirectModalStateData, toggleRedirectModal } =
    useRedirectModalState();

  const hasOneRedirect = redirects?.length === 1;

  const firstRedirectHasEmptyTitleAndDescription =
    redirects[0]?.description?.length === 0 &&
    redirects[0]?.title?.length === 0;

  const isDirectRedirect =
    hasOneRedirect && firstRedirectHasEmptyTitleAndDescription;

  const handleClick = useCallback(() => {
    if (isDirectRedirect) {
      changeRedirectModalStateData({
        title,
        redirectEnum: redirects[0]?.id,
      });

      toggleRedirectModal();
      return;
    }

    setOpenServicesModal(true);
  }, [redirects]);

  return (
    <>
      <ServiceItemCard primary={primary} onClick={handleClick}>
        {primary ? (
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            zIndex={1}
            width="100%"
          >
            <TextBox>
              <CardTitle>{title}</CardTitle>
              <CardDescription>{description}</CardDescription>
            </TextBox>
            {icon}
          </Stack>
        ) : (
          <Stack flexDirection="row" alignItems="flex-start" gap={1}>
            <IconBox justifyContent="center" alignItems="center">
              {icon}
            </IconBox>
            <Stack gap={0.5}>
              <CardTitle>{title}</CardTitle>
              <CardDescription>{description}</CardDescription>
            </Stack>
          </Stack>
        )}
      </ServiceItemCard>
      <ServiceModal
        openModal={openServicesModal}
        handleCloseModal={() => setOpenServicesModal(false)}
        title={title}
        redirects={redirects}
      />
    </>
  );
}
